import { ReactNode } from "react";
import { OptionCard } from "./OptionCard";

type VisualOption = {
  value: string;
  label: string;
  subtitle?: string;
  icon?: ReactNode;
};

type VisualStepProps = {
  title: string;
  description?: string;
  options: VisualOption[];
  value?: string;
  onChange: (value: string) => void;
};

export function VisualStep({
  title,
  description,
  options,
  value,
  onChange,
}: VisualStepProps) {
  return (
    <div className="space-y-6">
      <header className="space-y-1">
        <h2 className="text-xl font-bold text-[var(--text-primary)]">
          {title}
        </h2>

        {description && (
          <p className="text-sm text-[var(--text-muted)]">{description}</p>
        )}
      </header>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {options.map((opt) => {
          const isSelected = value === opt.value;

          return (
            <div key={opt.value} className="relative rounded-2xl">
              <span className="absolute top-3 right-3">
                {isSelected ? (
                  <span className="block h-5 w-5 rounded-full border-2 border-white bg-[var(--brand)] shadow-sm" />
                ) : (
                  <span className="block h-5 w-5 rounded-full border border-gray-300 bg-white" />
                )}
              </span>

              <OptionCard
                icon={opt.icon}
                title={opt.label}
                subtitle={opt.subtitle}
                selected={isSelected}
                onClick={() => onChange(opt.value)}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
